<template>
    <a-modal :visible="visible" :title="state.title" @cancel="handleModalCancel" width="60%" :destroy-on-close="true"
        :footer="null">
        <AForm ref="formRef" class="myform" :model="form" :rules="state.rules" @finish="handleOk"
            :wrapper-col="{ span: 14 }" :scroll-to-first-error="true">

            <!-- bulan -->
            <AFormItem label="Pilih Bulan" label-align="left" :label-col="{ sm: { span: 4 } }"
                :wrapper-col="{ sm: { span: 24 - 4 } }" required name="month" has-feedback>
                <AMonthPicker v-model:value="form.month" :allow-clear="false" placeholder="Pilih Bulan"
                    :disabled-date="disabledDate" format="MMMM YYYY" value-format="YYYY-MM" @change="fetchTargetDay"
                    :disabled="isEdit" style="width:100%;" />
            </AFormItem>

            <!-- target hari kerja -->
            <AFormItem label="Target Hari Kerja" label-align="left" :label-col="{ sm: { span: 4 } }"
                :wrapper-col="{ sm: { span: 24 - 4 } }" required name="target_hari_kerja" has-feedback>
                <AInputNumber placeholder="number" v-model:value="form.target_hari_kerja" style="width: 100%" />
            </AFormItem>

            <!-- target visit -->
            <AFormItem label="Target Visit" label-align="left" :label-col="{ sm: { span: 4 } }"
                :wrapper-col="{ sm: { span: 24 - 4 } }" required name="target_visit" has-feedback>
                <AInputNumber placeholder="number" v-model:value="form.target_visit" style="width: 100%" />
            </AFormItem>

            <!-- target efektif visit -->
            <!-- <AFormItem
                label="Target Efektif Visit"
                label-align="left"
                :label-col="{ sm: { span: 4 } }"
                :wrapper-col="{ sm: { span: 24 - 4 } }"
                name="target_efektif_visit"
                has-feedback>
                <AInputNumber
                    placeholder="number"
                    v-model:value="form.target_efektif_visit"
                    style="width: 100%"/>
            </AFormItem> -->

            <!-- target noo -->
            <!-- <AFormItem
                label="Target NOO"
                label-align="left"
                :label-col="{ sm: { span: 4 } }"
                :wrapper-col="{ sm: { span: 24 - 4 } }"
                required
                name="target_noo"
                has-feedback>
                <AInputNumber
                    placeholder="number"
                    v-model:value="form.target_noo"
                    style="width: 100%"/>
            </AFormItem> -->

            <!-- LEVEL -->
            <AFormItem :class="{ 'select-readonly': isEdit }" name="level_wilayah" label="Level Wilayah"
                label-align="left" :label-col="{ sm: { span: 4 } }" :wrapper-col="{ sm: { span: 24 - 4 } }"
                :rules="state.rules.level_wilayah">
                <ASelect v-model:value="form.level_wilayah" :options="LEVEL_WILAYAH_OPTIONS"
                    placeholder="Pilih Level Wilayah" @change="onChangeLevel" :disabled="isEdit"
                    :open="isEdit ? false : undefined" @mousedown.prevent="isEdit" style="width:100%" />
            </AFormItem>

            <!-- GROUP WILAYAH -->
            <AFormItem v-if="form.level_wilayah === 2" name="entitas" label="Mapping Wilayah" label-align="left"
                :rules="[{ required: true, message: 'Mapping Wilayah wajib dipilih' }]" :label-col="{ sm: { span: 4 } }"
                :wrapper-col="{ sm: { span: 20 } }">

                <ASelect v-model:value="form.entitas" :options="state.groupOptions" :loading="state.loadingGroup"
                    placeholder="Pilih Mapping Wilayah" @change="onChangeEntitas" style="width:100%"
                    :disabled="isEdit" />
            </AFormItem>

            <!-- WILAYAH -->
            <AFormItem v-if="form.level_wilayah !== 0" :class="{ 'select-readonly': isEdit }" name="wilayah_id"
                label="Wilayah" label-align="left" :rules="state.rules.wilayah_id" :label-col="{ sm: { span: 4 } }"
                :wrapper-col="{ sm: { span: 20 } }">
                <ASelect v-model:value="form.wilayah_id" :key="form.entitas"
                    :mode="(form.level_wilayah === 1 && !isEdit) || form.level_wilayah === 2 ? 'multiple' : undefined"
                    :options="state.wilayahOptions" :loading="state.loadingWilayah"
                    :disabled="form.level_wilayah === 0 || form.level_wilayah === 2 || isEdit" show-search
                    :filter-option="false" @search="onSearch"
                    @change="form.level_wilayah === 1 ? onChangeWilayah : null" placeholder="Pilih Wilayah"
                    style="width:100%" />
            </AFormItem>

            <!-- BUTTON -->
            <ARow v-if="!form.readOnly" class="form-row" type="flex" justify="end">
                <ACol>
                    <AFormItem>
                        <a-button type="primary" html-type="submit" :loading="form.busy" :disabled="form.busy">{{
                            !form.id ? 'Simpan' : 'Perbarui'
                            }}</a-button>
                    </AFormItem>
                </ACol>
            </ARow>
        </AForm>

        <div v-if="state.errors">
            <ASpace>
                <AAlert v-for="(item, index) in state.errors" type="error" :key="index" :message="item" banner closable
                    @close="state.errors = []" />
            </ASpace>
        </div>
    </a-modal>
</template>
<script>
import {
    defineComponent,
    onMounted,
    reactive,
    ref,
    computed,
    nextTick,
} from 'vue'
import { debounce } from 'lodash'
import apiClient from '@/services/axios'
import { Modal, message } from 'ant-design-vue'
import moment from 'moment'
import {
    ROLE_ADMIN_BK,
    hasRoles,
} from '@/helpers'

export default defineComponent({
    components: {
        // 
    },
    props: {
        visible: Boolean,
        item: Object,
    },
    emits: ['update:visible', 'success'],

    setup(props, { emit }) {
        const form = reactive({
            id: props.item.month,
            month: null,
            target_hari_kerja: null,
            target_visit: null,
            target_efektif_visit: null,
            // target_noo: null,
            level_wilayah: 0,
            wilayah_id: [],
            entitas: null,
        })

        const isEdit = computed(() => !!form.id)

        const formRef = ref()

        const state = reactive({
            title: computed(() =>
                isEdit.value ? 'Edit Master Data SFC' : 'Tambah Master Data SFC',
            ),
            endpoint: '/api/atsalesman/salesman-target-sfc',
            data: [],
            page: 1,
            per_page: 1,
            total: 0,
            loading: false,
            rules: {
                month: [
                    {
                        required: true,
                        message: 'Bulan tidak boleh kosong!',
                    },
                ],
                target_hari_kerja: [
                    {
                        required: true,
                        message: 'Target hari kerja tidak boleh kosong!',
                    },
                ],
                target_visit: [
                    {
                        required: true,
                        message: 'Target visit tidak boleh kosong!',
                    },
                ],
                // target_noo: [
                //     {
                //         required: true,
                //         message: 'Target NOO tidak boleh kosong!',
                //     },
                // ],
                level_wilayah: [
                    {
                        validator: (_, val) => {
                            if (val === null || val === undefined) {
                                return Promise.reject('Level wilayah wajib dipilih!')
                            }
                            return Promise.resolve()
                        },
                        trigger: 'change',
                    },
                ],
                wilayah_id: [
                    {
                        validator: (_, val) => {
                            if (Number(form.level_wilayah) === 0) return Promise.resolve()

                            if (isEdit.value) {
                                if (!val) {
                                    return Promise.reject('Wilayah wajib dipilih')
                                }
                            } else {
                                if (!val || val.length === 0) {
                                    return Promise.reject('Wilayah wajib dipilih')
                                }
                            }

                            return Promise.resolve()
                        },
                        trigger: 'change',
                    },
                ],
            },
            errors: [],
            groupOptions: [],
            loadingGroup: false,
            wilayahOptions: [],
            loadingWilayah: false,
        })

        const handleModalCancel = () => {
            emit('update:visible', false)
            emit('update:item', null)
        }

        const disabledDate = (current) => {
            return current && current < moment().startOf('month')
        }

        const LEVEL_WILAYAH_OPTIONS = [
            { label: 'All', value: 0 },
            { label: 'Provinsi', value: 1 },
            { label: 'Group Wilayah', value: 2 },
            // { label: 'Kabupaten', value: 2 },
            // { label: 'Kecamatan', value: 3 },
            // { label: 'Desa', value: 4 },
        ]

        const searchText = ref('')

        const onSearch = debounce((val) => {
            searchText.value = val
            if (form.level_wilayah !== 0) {
                fetchWilayah(form.level_wilayah)
            }
        }, 300)

        const fetchWilayah = async (level) => {
            state.loadingWilayah = true
            try {
                const { data } = await apiClient.get(`/api/filter/wilayah/${level}`, {
                    params: { q: searchText.value || null },
                })

                state.wilayahOptions = data.map(i => ({
                    label: i.name,
                    value: Number(i.id),
                }))
            } finally {
                state.loadingWilayah = false
            }
        }

        const onChangeLevel = async (val) => {
            const level = Number(val ?? 0)

            form.level_wilayah = level
            form.wilayah_id = isEdit.value ? null : [] // ⬅️ FIX
            form.entitas = null

            state.wilayahOptions = []
            state.groupOptions = []

            formRef.value?.clearValidate(['level_wilayah', 'wilayah_id', 'entitas'])

            if (level === 0) return

            if (level === 2) {
                await fetchGroupWilayah()
                return
            }

            await fetchWilayah(level)
        }

        const onChangeWilayah = (val) => {
            if (form.level_wilayah === 2) return

            if (isEdit.value) {
                form.wilayah_id = val ? Number(val) : null
            } else {
                form.wilayah_id = Array.isArray(val)
                    ? val.map(v => Number(v))
                    : []
            }
        }

        const fetchGroupWilayah = async () => {
            state.loadingGroup = true
            try {
                const { data } = await apiClient.get('/api/filter/ats-group-wilayah-sfc')

                state.groupOptions = data.map(i => ({
                    label: i.group_wilayah_name,
                    value: Number(i.id),
                    wilayahs: i.wilayahs || [],
                }))
            } finally {
                state.loadingGroup = false
            }
        }

        const onChangeEntitas = async (val) => {
            form.entitas = val

            const selected = state.groupOptions.find(i => i.value === val)

            if (selected) {
                const options = selected.wilayahs.map(w => ({
                    label: w.name,
                    value: Number(w.id),
                }))

                state.wilayahOptions = options

                // 🔥 WAJIB: tunggu options ke-render dulu
                await nextTick()

                form.wilayah_id = options.map(o => o.value)
            } else {
                state.wilayahOptions = []
                form.wilayah_id = []
            }
        }

        const handleOk = async () => {
            // validation form
            try {
                await formRef.value.validate()
            } catch {
                return
            }

            const payload = {
                ...form,
                level: form.level_wilayah === 2 ? 6 : null,
                level_wilayah: Number(form.level_wilayah ?? 0),
                wilayah_id:
                    form.level_wilayah === 0
                        ? null
                        : form.level_wilayah === 2
                            ? form.wilayah_id // ⬅️ wilayah tidak dipakai
                            : (isEdit.value
                                ? form.wilayah_id
                                : (form.wilayah_id.length ? form.wilayah_id : null)), // multiple
                entitas:
                    form.level_wilayah === 2 ? form.entitas : null,
            }

            try {
                const { data } = form.id
                    ? await apiClient.put(`${state.endpoint}/${form.id}`, payload)
                    : await apiClient.post(`${state.endpoint}`, payload)

                if (data.success) {
                    message.success(data.message)

                    handleModalCancel()
                    emit('success', data)
                    emit('update:visible', false)
                    return
                }

                message.error(data.errors)
            } catch (err) {
                const data = err?.response?.data

                if (data) {
                    state.errors = typeof data.errors === 'object'
                        ? Object.values(data.errors)
                        : [data.errors || 'Terjadi kesalahan']
                } else {
                    state.errors = ['Terjadi kesalahan jaringan']
                }
            }
        }

        const ensureOptionExists = async (ids) => {
            if (!ids) return

            const idList = Array.isArray(ids) ? ids : [ids]

            for (const id of idList) {
                const exist = state.wilayahOptions.find(i => i.value === id)

                if (!exist) {
                    const { data } = await apiClient.get(`/api/wilayah/${id}`)
                    state.wilayahOptions.push({
                        label: data.name,
                        value: Number(data.id),
                    })
                }
            }
        }

        onMounted(async () => {
            if (!props.item) return

            Object.assign(form, {
                ...props.item,
                level_wilayah: Number(props.item.level_wilayah ?? 0),
                wilayah_id: props.item.wilayah_id
                    ? Array.isArray(props.item.wilayah_id)
                        ? props.item.wilayah_id.map(Number)
                        : [Number(props.item.wilayah_id)]
                    : [],
                entitas: props.item.entitas ? Number(props.item.entitas) : null,
            })

            if (form.level_wilayah === 2) {
                await fetchGroupWilayah()

                // 🔥 pastikan option ada
                const selected = state.groupOptions.find(i => i.value === form.entitas)

                if (selected) {
                    state.wilayahOptions = selected.wilayahs.map(w => ({
                        label: w.name,
                        value: Number(w.id),
                    }))

                    // 🔥 override wilayah_id dari entitas
                    form.wilayah_id = state.wilayahOptions.map(o => o.value)
                }

                return
            }

            // selain level 2
            if (form.level_wilayah !== 0) {
                await fetchWilayah(form.level_wilayah)
            }

            if (form.wilayah_id?.length) {
                await ensureOptionExists(form.wilayah_id)
            }
        })

        return {
            formRef,
            handleOk,
            form,
            state,
            handleModalCancel,
            disabledDate,
            LEVEL_WILAYAH_OPTIONS,
            onSearch,
            isEdit,
            onChangeLevel,
            onChangeWilayah,
            onChangeEntitas,
        }
    },
})
</script>

<style lang="scss" scoped>
@import '@/assets/scss/form.scss';

.select-readonly .ant-select-selector {
    background-color: #f5f5f5 !important;
    cursor: not-allowed !important;
}
</style>
